<div class="container-fluid gx-0 gx-lg-4 container-lg">
	<div class="steps">
		<span
			class="step"
			*ngFor="let step of steps; let i = index"
			[ngClass]="{
				active: selectedIndex === i,
				completed: step.completed && i < selectedIndex,
				done: step.state === 'done' && i === selectedIndex,
				connectors: showConnectors
			}"
		>
			<ng-container
				*ngIf="step.stepLabel"
				[ngTemplateOutlet]="step.stepLabel.template"
			>
			</ng-container>

			<ng-container *ngIf="!step.stepLabel">
				<div class="step-bullet">
					<ng-container *ngIf="step.completed && i < selectedIndex">
						<i class="bi bi-check2 step-bullet-icon"></i>
					</ng-container>
					<ng-container
						*ngIf="!(step.completed && i < selectedIndex)"
					>
						{{ i + 1 }}
					</ng-container>
				</div>
				<div *ngIf="showLabels" class="step-title d-none d-md-block">
					{{ step.label }}
				</div>
			</ng-container>
		</span>
	</div>

	<div class="stepper-body">
		<div [ngTemplateOutlet]="selected ? selected.content : null"></div>
	</div>
</div>
